import * as Sentry from "@sentry/browser";

const CHATBOT_IFRAME_SELECTOR = 'iframe#nm_chat_iframe';
const CHATBOT_CLASS_NAME_OPEN = 'nm_chat--open';
const CHATBOT_OPEN_LINK_SELECTOR = '[href="#open-chatbot"]';

/**
 * See: NEOS Project `neos/DistributionPackages/Louis.Site/Resources/Private/Fusion/Presentation/Component/Chatbot/`
 */
function init() {
    try {
        // don't initialize in Neos CMS backend
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        const iframeElements = document.querySelectorAll<HTMLIFrameElement>(CHATBOT_IFRAME_SELECTOR);
        if (iframeElements.length === 0) {
            return;
        }

        const chatbotIframeSrc = iframeElements[0].dataset.src;
        const chatbotOrigin = (new URL(chatbotIframeSrc)).origin;

        iframeElements.forEach(iframeElement => {
            iframeElement.src = chatbotIframeSrc;
            iframeElement.onload = () => {
                const louisReferer = window.location ? window.location.href : window.opener.location.href;

                iframeElement.contentWindow.postMessage(
                    {
                        sender: "get_parent_url",
                        message: louisReferer,
                    },
                    chatbotOrigin
                );
            };
            // unhide iframe after initialization
            iframeElement.style.display = "";
        });

        window.addEventListener("message", createChatbotMsgHandler(chatbotOrigin));

        document.querySelectorAll(CHATBOT_OPEN_LINK_SELECTOR).forEach(link => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                document.querySelectorAll<HTMLIFrameElement>(CHATBOT_IFRAME_SELECTOR).forEach(iframe => {
                    iframe.contentWindow?.postMessage(
                        "increaseNMiFrame",
                        chatbotOrigin,
                    );
                });
                event.stopPropagation();
            });
        });
    } catch (e) {
        Sentry.captureException(e);
    }
}

function createChatbotMsgHandler(expectedMessageOrigin: string) {
    return function handleMessageFromChatbot(event: MessageEvent) {
        if (event.origin === expectedMessageOrigin) {
            switch (event.data) {
                case "increaseNMiFrame":
                    openChatbot();
                    break;
                case "decreaseNMiFrame":
                    closeChatbot();
                    break;
                default:
            }
        }
    }
}

function openChatbot() {
    document.querySelectorAll(CHATBOT_IFRAME_SELECTOR).forEach(iframeElement =>
        iframeElement.classList.add(CHATBOT_CLASS_NAME_OPEN)
    );
}

function closeChatbot() {
    document.querySelectorAll(CHATBOT_IFRAME_SELECTOR).forEach(iframeElement =>
        iframeElement.classList.remove(CHATBOT_CLASS_NAME_OPEN)
    );
}

export default {
    init,
}
